import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "./api";
import FooterLogo from "./FooterLogo";

export default function VerifyWaiting() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkQueue = async () => {
      try {
        const res = await api.get("/verify/current");

        if (res.data.requestNumber) {
          navigate(`/verify/${res.data.requestNumber}`, {
            state: {
              verifyId: res.data.verifyId,
            },
          });
        }
      } catch (err) {
        console.error("Verification check failed", err);
      }
    };

    // Check immediately
    checkQueue();

    // Then every second
    const interval = setInterval(checkQueue, 1000);

    return () => clearInterval(interval);
  }, [navigate]);

  return (
<div
  className="min-h-screen flex flex-col"
  style={{
    backgroundImage:
      "radial-gradient(circle at top left, #A8A8A8, #8C8C8C, #85D3DE, #8DDFEB)",
  }}
>

  <div className="flex-1 flex items-center justify-center">

    <div className="bg-white/30 backdrop-blur-md rounded-xl shadow-xl p-10 text-center border border-white/40">

      <img
        src="/InfoMedi_logo.png"
        alt="InfoMedi Logo"
        className="h-20 mx-auto mb-8"
      />

      <h1 className="text-3xl font-semibold text-gray-800">
        Waiting...
      </h1>

      <p className="text-gray-700 mt-4">
        Waiting for the next patient.
      </p>

    </div>

  </div>

  <FooterLogo />

</div>
  ); 
}